export default __webpack_public_path__ + "static/media/Background_00183.67870f68.png";